export default "__VITE_ASSET__DMODjED9__"